<template>
	<div class="content-page content-page--companies">
		<div class="content-page__heading">
			<div class="content-page__breadcrumb-title">
				<Breadcrumbs :items="urlNames" />
				<h2 class="content-page__title">
					{{ customerName }}
					<span class="content-page__title--detail"
						>- Companies</span
					>
				</h2>
			</div>
		</div>
		<div class="results-toolbar results-toolbar--variant-one">
			<div class="results-toolbar__search">
				<Search
					variant="toggle-icons"
					placeholder="Search by company name"
					v-model="search"
				/>
			</div>
			<div class="results-toolbar__counter">
				<ResultCounter :counter="companies.length" />
			</div>
		</div>
		<ScrollContainer :selectorArray="pageElements" :extraSpace="70">
			<ul class="companies__result-list">
					<CompaniesCard
						v-for="(company, index) in companies"
						:key="index"
						:companyData="{
							customerName,
							data: company
						}"
					/>
			</ul>
		</ScrollContainer>
	</div>
</template>

<script>
import Breadcrumbs from '@/components/shells/breadcrumbs/breadcrumbs';
import ResultCounter from '@/site-components/result-counter/result-counter';
import Search from '@/components/forms/search/search';
import ScrollContainer from '@/components/shells/scroll-container/scroll-container';
import CompaniesCard from './companies-card.vue';
import { ApiService as api } from '@/services/axiosHelper';

export default {
	name: 'CompaniesPage',
	components: {
		Breadcrumbs,
		ResultCounter,
		Search,
		ScrollContainer,
		CompaniesCard
	},
	created() {
		//getting data from $route
		const {
			search = '',
			customerName = '',
			companies = []
		} = this.$route.params;
		this.search = search;
		this.customerName = customerName;
		this.companies = companies;

		//fetch data if url was copied and there is one company or none
		if (!this.companies.length) {
			this.fetchCustomer();
		}
	},
	data() {
		return {
			search: '',
			customerName: '',
			companies: [],
			urlNames: [
				{
					name: 'Clients',
					data: {
						path: '/clients'
					}
				}
			],
			pageElements: [
				'header.site__header',
				'footer.site__footer',
				'.content-page__heading',
				'.results-toolbar--variant-seven'
			]
		};
	},
	methods: {
		async fetchCustomer() {
			const results = await api.get(`customers/${this.$route.params.id}`);
			console.log(results);
		}
	}
};
</script>

<style lang="scss" scoped>

	::v-deep .results-toolbar .results-toolbar__search {
		width: 300px;
	}

	.companies {
		&__result-list {
			display: grid;
			grid-template-columns: 1fr;
			gap: $gutter-lg;

			@include mq($from: md) {
				grid-template-columns: 1fr 1fr;
			}

			@include mq($from: lg) {
				grid-template-columns: 1fr 1fr 1fr;
			}
		}
	}
</style>
